<template>
  <div>
    <v-btn bottom
           color="#26c6da"

           dark
           fab
           fixed
           right
           @click="dialog = !dialog">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog
        v-model="dialog"
        width="800px">
      <v-card light>
        <v-card-title class=" darken-2">
          Nuevo item
        </v-card-title>
        <v-container>
          <v-row align="center"
                 justify="center">
            <v-col cols="10" md="6">
              <v-text-field type="text" label="título" v-model="name"/>
            </v-col>
            <v-col cols="10" md="6">
              <v-text-field type="text" label="descripción" v-model="description"/>
            </v-col>
            <v-col cols="10" md="4">
              <v-text-field type="number" label="precio" v-model="price"/>
            </v-col>
            <v-col cols="10" md="4">
              <v-text-field type="number" label="cantidad" v-model="qty"/>
            </v-col>
            <v-col cols="10" md="4">
              <v-text-field type="number" label="descuento" v-model="discount"/>
            </v-col>
            <v-col cols="10" md="3" style="display: inline-flex;">
              <v-btn                 color="#26c6da"
                                     dark v-on:click="saveZone">Guardar</v-btn>
              <v-btn class="ml-2" outlined style="margin: 0 auto;" text @click="dialog = false">Cerrar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "newitem",
  props:['refresh'],
  data: () => ({
    dialog: false,
    name:'',
    description:'',
    price:0,
    qty:0,
    discount:0
  }),
  mounted() {
    this.getClients()
  },
  methods: {

    saveZone() {
      let formData = new FormData();
      formData.set('pid', this.$route.params.id);
      formData.set('title', this.name);
      formData.set('description', this.description);
      formData.set('price', this.price);
      formData.set('qty', this.qty);
      formData.set('discount', this.discount);
      formData.set('token', localStorage.token);
      let url = this.base_url + "/invV2/admin/nuevoitemproyecto/";
      this.axios.post(url, formData).then(() => {
        this.dialog = false;
        this.name='';
        this.description='';
        this.price = 0;
        this.qty = 0;
        this.discount = 0;
        this.refresh();
      });
    }
  }
}
</script>

<style scoped>

</style>
